import request from "@/utils/request";

export default function agentBindCardForWeChat(params) {
    return request({
        url: `/user/card/agentBindCardForWeChat`,
        method: 'post',
        params: params
    })
}
